import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-user-property-detail',
  templateUrl: './user-property-detail.component.html',
  styleUrls: ['./user-property-detail.component.css']
})
export class UserPropertyDetailComponent implements OnInit {

  propertyDetailsPage = true;

  prop_id = '';
  modelData: any = {};
  ulb_data: any = [];
  property_detail: any = [];
  selectAll = false;

  property_id: any;
  billData: any = {};
  is_partial_payment = false;
  amount = 0;
  redirection_payment = null;
  user_details: any = [];
  user_dtl: any = [];
  name = '';
  email = '';
  mobile_no = '';
  isMessageShow = false;
  selectedRowIndex = 0;


  constructor(private apiService: ApiService,
    private activatedRoute: ActivatedRoute, 
    private appComponent: AppComponent, private router: Router) { }

  ngOnInit(): void {
    this.prop_id = this.activatedRoute.snapshot.params['id'];
    this.activatedRoute.queryParams
      .subscribe(params => {
        this.redirection_payment = params['payment'];
      }
    );
    this.getSearviceNumberList();

    this.user_details = localStorage.getItem("loginDetails");
    if(this.user_details == null){
      this.router.navigate(['/login'], { queryParams: { returnUrl: '/user-property-list' }});
    }
    this.user_dtl = JSON.parse(this.user_details).user[0];
    this.name= this.user_dtl.name;
    this.email= this.user_dtl.email;
    this.mobile_no= this.user_dtl.mobile_no;
  }

  getSearviceNumberList() {
    this.appComponent.showLoader();
    this.apiService.getCitizenData(`get_property/${this.prop_id}`).subscribe(
      (res: any) => {
        this.property_detail = res['data'];
        // this.property_detail.services.forEach((val: any)=>{
        //     this.amount += parseFloat(val.payable_total_amount);
        // });
        this.amount = parseFloat(this.property_detail.services[0].payable_total_amount);
        this.appComponent.hideLoader();
      },
      (error) => {
        this.appComponent.hideLoader();
        this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      })
  }

  onSelectAllChange() {
    if (this.selectAll) {
      this.property_detail.services.map((val: any) => val.ischecked = true);
    } else {
      this.property_detail.services.map((val: any) => val.ischecked = false);
    }
  }

  onClickPay(){
    // this.propertyDetailsPage = false;
    this.makePayment();
  }

  // onPartialPaymentChange() {
  //   console.log(this.is_partial_payment)
  //   if (this.is_partial_payment) {
  //     this.amount = this.billData.bill.amount;
  //   } else {
  //     this.amount = this.billData.bill.payable_amount;
  //   }
  // }

  makePayment() {
    if(this.property_detail.services.length <= 1){
      this.property_detail.services[0].ischecked = true;
    };

    

    let properties: any = [];
    // this.property_detail.services.forEach((val: any)=>{
    //   if(val.ischecked){
    //      properties.push({
    //         "service_type_id": val.service_type_id,
    //         "property_id": val.property_id
    //     });
    //     this.amount += parseFloat(val.payable_total_amount);
    //     }
    // });
    
    let _property  = this.property_detail?.services[this.selectedRowIndex];
    properties.push({
              "service_type_id": _property.service_type_id,
              "property_id": _property.property_id
          });

    let formData = {
      payment_gateway_id: 1,
      amount: this.amount,
      is_partial_payment: this.is_partial_payment,
      consumer_detail_id: this.property_detail.consumer_id,
      "properties": properties
    }

    this.appComponent.showLoader();

    this.apiService.post(`make_payment`, formData).subscribe(
      (res: any) => {
        const product = res.data;
        
        this.appComponent.hideLoader();

        const paymentDetails = {
          payu_url: product.payu_url,
          first_name: product.first_name,
          email: product.email,
          mobile: product.mobile,
          callback_url: product.call_back_url,
          payu_cancel_url: product.payu_cancel_url,
          payu_fail_url: product.payu_fail_url,
          payu_merchant_key: product.payu_merchant_key,
          payu_sha_token: product.payu_sha_token,
          txnid: product.txnId,
          plan_name: product.plan_name,
          amount: product.amount,
          service_provider: product.service_provide
        };

        let paymentString = `
          <html>
            <body>
              <form action="${paymentDetails.payu_url}" method="post" id="payu_form">
                <input type="hidden" name="firstname" value="${paymentDetails.first_name}"/>
                <input type="hidden" name="email" value="${paymentDetails.email}"/>
                <input type="hidden" name="phone" value="${paymentDetails.mobile}"/>
                <input type="hidden" name="surl" value="${paymentDetails.callback_url}"/>
                <input type="hidden" name="curl" value="${paymentDetails.payu_cancel_url}"/>
                <input type="hidden" name="furl" value="${paymentDetails.payu_fail_url}"/>
                <input type="hidden" name="key" value="${paymentDetails.payu_merchant_key}"/>
                <input type="hidden" name="hash" value="${paymentDetails.payu_sha_token}"/>
                <input type="hidden" name="txnid" value="${paymentDetails.txnid}"/>
                <input type="hidden" name="productinfo" value="${paymentDetails.plan_name}"/>
                <input type="hidden" name="amount" value="${paymentDetails.amount}"/>
                <input type="hidden" name="service_provider" value="${paymentDetails.service_provider}"/>
                <button type="submit" value="submit" #submitBtn></button>
              </form>
              <script type="text/javascript">document.getElementById("payu_form").submit();</script>
            </body>
          </html>`;

        const winUrl = URL.createObjectURL(
          new Blob([paymentString], { type: "text/html" })
        );

        window.location.href = winUrl;
      },
      (error) => {
        this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
        this.appComponent.hideLoader();
      })
  }

  checkBoxChange(event: any, i: any){
      console.log(event)
  }

  logout(){
    this.appComponent.logout();
  }


}
